var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "24px",
    viewBox: "0 0 13 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "down-arrow-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Introducing-Hana-UI",
    transform: "translate(-252.000000, -342.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down-arrow-2",
    transform: "translate(258.500000, 354.000000) rotate(-90.000000) translate(-258.500000, -354.000000) translate(246.500000, 347.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.237521,0.772124585 C22.8869956,0.409817609 22.3181949,0.409261568 21.9669058,0.770780819 L12.6352851,10.3763408 C12.2849394,10.7376747 11.7150156,10.7376284 11.364041,10.3756458 L2.03309416,0.770780819 C1.68185004,0.409215231 1.11304928,0.409817609 0.76247898,0.772124585 C0.411998526,1.13443156 0.41258251,1.72119371 0.763781715,2.08271296 L10.0940997,11.6869292 C10.6197305,12.2290227 11.3099551,12.5 12.0002695,12.5 C12.6901797,12.5 13.3802246,12.2291154 13.9051816,11.6875779 L23.2362183,2.08271296 C23.5874175,1.72119371 23.5880015,1.13443156 23.237521,0.772124585 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.e63d3bdf.svg";
export { ForwardRef as ReactComponent };